import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL, API_KEY_ID, API_KEY_SECRET } from "../../constant";
import axios from "axios";

/**
 * Fetch Product Details
 */
export const fetchProductDetails = createAsyncThunk('product/fetchProductDetails', async (product, { rejectWithValue }) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/product/${product}`, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET
            }
        });
        // return { product, products: res.data };
        return res.data

    } catch (error) {
        const errorMessage = error.response ? error.response.data : error.message;
        return rejectWithValue(errorMessage);
    }
});

/**
 * Search Products
 */
export const searchQ = createAsyncThunk('product/searchQ', async (query, { rejectWithValue }) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/search?keyword=${query}`, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET
            }
        });
        
        console.log("Search q", res.data)
        return res.data

    } catch (error) {
        const errorMessage = error.response ? error.response.data : error.message;
        return rejectWithValue(errorMessage);
    }
});
